export default[
    {
        path: '/depedentes/cadastro/:id',
        name: 'cadastro de dependente', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/depedentes/lista/:id',
        name: 'lista do dependente', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/depedentes/editar/:trabalhador/:id',
        name: 'editar dependente', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]